<template>
  <div>
    <modal @close="handleClose" :show.sync="showCam" headerclasses="justify-content-center" :showClose="false" modalClasses="capture-modal m-0 d-flex h-100 mw-100" bodyClasses="d-flex p-0" footerClasses="d-none">
      <div style="flex: 1;position: relative">

        <div v-if="isCameraOpen" v-show="!isLoading" class="camera-box" :class="{ 'flash' : isShotPhoto }" style="height: calc(100% - 82px);display: flex;justify-content: center;align-items: center;">

          <div class="camera-shutter" :class="{'flash' : isShotPhoto}"></div>
          <div class="preloader-scan">
            <video v-show="!isPhotoTaken" ref="video" autoplay style="width: 100vw;height: 100vh;object-fit: cover;"></video>
            <ul>
              <div class="diode">
                <div class="laser"></div>
              </div>
            </ul>
          </div>

          <!--           <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas"></canvas> -->
          <canvas id="photoTaken" ref="canvas" style="display: none;"></canvas>
        </div>

        <div v-if="isCameraOpen && !isLoading" class="camera-shoot">
          <n-button type="primary" round @click.native="closeCaptureModal" icon size="lg">
            <i class="fas fa-times"></i>
          </n-button>

          <span style="font-size: 1.5em;display: flex;justify-content: center;align-items: center;">Scanning...</span>
          <!--
          <n-button type="primary" round @click.native="saveImage" icon size="lg" v-if="isPhotoTaken">
            <i class="fas fa-check"></i>
          </n-button> -->

          <!--           <n-button type="primary" round @click.native="takePhoto" icon size="lg" v-if="!isPhotoTaken">
            <i class="fas fa-camera"></i>
          </n-button> -->
          <!--
          <n-button type="primary" round @click.native="createCameraElement" icon size="lg" v-if="isPhotoTaken">
            <i class="fas fa-undo"></i>
          </n-button> -->

          <n-button type="primary" round @click.native="switchCamera" icon size="lg" v-if="!isPhotoTaken">
            <i class="fas fa-sync-alt"></i>
          </n-button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
export default {
  name: "app-camera",

  components: {},

  data() {
    return {
      videoConstraints: {
        facingMode: "environment",
        width: { ideal: 240 },
        height: { ideal: 360 },
      },
      cameraStream: null,
      isCameraOpen: true,
      isPhotoTaken: false,
      isShotPhoto: false,
      isLoading: false,
      initTimeOut: null,
      waitingForApiResponse: false,
      apiInterval: null,
      camTimeOut: null,
    };
  },

  props: ["showCam"],

  computed: {},
  beforeDestroy() {
    clearTimeout(this.initTimeOut);
    clearTimeout(this.camTimeOut);
    clearInterval(this.apiInterval);
  },
  watch: {
    showCam: function (v) {
      if (v) {
        let that = this;
        this.camTimeOut = setTimeout(() => {
          that.createCameraElement();
        }, 1000);
      } else {
        this.waitingForApiResponse = false;
        clearTimeout(this.initTimeOut);
        clearTimeout(this.camTimeOut);
        clearInterval(this.apiInterval);
      }
    },
  },
  methods: {
    handleClose() {
      // listen to modal close the camera scanner close.
      this.$emit("onClose");
    },
    closeCaptureModal() {
      if (this.cameraStream) {
        this.cameraStream.getTracks().forEach(function (track) {
          track.stop();
        });
      }

      this.isPhotoTaken = false;

      this.$emit("onClose");
    },
    async saveImage() {
      let fileData = this.$refs.canvas
        .toDataURL("image/jpeg")
        .replace("image/jpeg", "image/octet-stream");

      this.closeCaptureModal();
      this.$emit("imageCaptured", fileData);
    },
    async findId() {
      try {
        this.waitingForApiResponse = true;
        this.$refs.canvas.width = this.$refs.video.videoWidth;
        this.$refs.canvas.height = this.$refs.video.videoHeight;

        const context = this.$refs.canvas.getContext("2d");
        context.drawImage(
          this.$refs.video,
          0,
          0,
          this.$refs.canvas.width,
          this.$refs.canvas.height
        );
        let fileData = this.$refs.canvas.toDataURL("image/png");

        if (fileData) {
          cordova.plugins.CarenationDevicesPlugin.recognizeText(
            fileData,
            (text) => {
              console.log(text);
              let regex = /^784-[0-9]{4}-[0-9]{7}-[0-9]{1}$/; // UAE ID Number reqex
              if (
                this.settings &&
                this.settings.idCardScanner &&
                this.settings.idCardScanner.regEx
              ) {
                try {
                  regex = new RegExp(this.settings.idCardScanner.regEx);
                } catch (e) {
                  regex = /^784-[0-9]{4}-[0-9]{7}-[0-9]{1}$/; // UAE ID Number reqex
                  console.log(e);
                }
              }
              console.log(regex);
              for (let _text of text) {
                let words = _text.split("\n");
                for (let word of words) {
                  if (regex && regex.test && regex.test(word)) {
                    if (this.cameraStream) {
                      this.cameraStream.getTracks().forEach(function (track) {
                        track.stop();
                      });
                    }
                    this.$emit("idFound", word);
                    this.waitingForApiResponse = false;
                    return;
                  }
                }
              }
            },
            (e) => {
              this.waitingForApiResponse = false;
              console.log("Error", e);
            }
          );
        }
        this.waitingForApiResponse = false;
      } catch (e) {
        this.waitingForApiResponse = false;
        console.log(e);
      }
    },
    takePhoto() {
      if (!this.isPhotoTaken) {
        this.isShotPhoto = true;

        const FLASH_TIMEOUT = 50;

        setTimeout(() => {
          this.isShotPhoto = false;
        }, FLASH_TIMEOUT);
      }

      this.isPhotoTaken = !this.isPhotoTaken;

      this.$refs.canvas.width = this.$refs.video.videoWidth;
      this.$refs.canvas.height = this.$refs.video.videoHeight;

      const context = this.$refs.canvas.getContext("2d");
      context.drawImage(
        this.$refs.video,
        0,
        0,
        this.$refs.canvas.width,
        this.$refs.canvas.height
      );
    },
    createCameraElement() {
      let that = this;
      this.isLoading = true;
      this.isPhotoTaken = false;

      const constraints = {
        audio: false,
        video: this.videoConstraints,
      };

      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          that.isLoading = false;
          that.cameraStream = stream;
          that.$refs.video.srcObject = stream;
          that.initTimeOut = setTimeout(() => {
            that.apiInterval = setInterval(() => {
              if (!that.waitingForApiResponse) {
                that.findId();
              }
            }, 500);
            that.initTimeOut = setTimeout(() => {
              if (that.cameraStream) {
                that.cameraStream.getTracks().forEach(function (track) {
                  track.stop();
                });
              }

              that.$emit("notFound");
            }, 30000);
          }, 1000);
        })
        .catch((error) => {
          console.log(error);
          that.isLoading = false;
          that.switchCamera();
          //alert("May the browser didn't support or there is some errors.");
        });
    },
    switchCamera() {
      let that = this;
      if (this.cameraStream) {
        this.cameraStream.getTracks().forEach(function (track) {
          track.stop();
        });
      }
      this.videoConstraints.facingMode =
        this.videoConstraints.facingMode == "environment"
          ? "user"
          : "environment";

      var mediaConstraints = {
        audio: false,
        video: this.videoConstraints,
      };

      navigator.mediaDevices
        .getUserMedia(mediaConstraints)
        .then(function (stream) {
          that.isLoading = false;
          that.cameraStream = stream;
          that.$refs.video.srcObject = stream;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.camera-shoot {
  display: flex;
  place-content: center;
  position: absolute;
  bottom: 0px;
  inset-inline-end: 50%;
  transform: translateX(50%);
  width: 100%;
  justify-content: space-around;
}
[dir="rtl"] .camera-shoot {
  transform: translateX(-50%);
}

.camera-shutter {
  opacity: 0;
  width: 450px;
  height: 337.5px;
  background-color: #fff;
  position: absolute;
  border: 0 px;
  height: 100%;
}
.camera-shutter.flash {
  opacity: 1;
}

/deep/.capture-modal .modal-body {
  min-height: 90vh;
}
/deep/.capture-modal .modal-header {
  display: none;
}

.preloader-scan {
  width: 100%;
}

.preloader-scan ul {
  height: 100%;
  display: table-cell;
  vertical-align: middle;
  list-style-type: none;
  text-align: center;
}

.preloader-scan .laser {
  width: 150%;
  margin-left: -25%;
  background-color: tomato;
  height: 1px;
  position: absolute;
  top: 29%;
  z-index: 2;
  box-shadow: 0 0 4px red;
  animation: scanning 2s infinite;
}
.preloader-scan .diode {
  animation: beam 0.01s infinite;
}

@keyframes beam {
  50% {
    opacity: 0;
  }
}
@keyframes scanning {
  50% {
    transform: translateY(240px);
  }
}
</style>
